export enum CounterpartyDistinctField {
  Manager = 'Менеджер',
  Segment = 'Сегмент',
  Region = 'Регион',
  City = 'Город',
}

export const COUNTERPARTY_DISTINCT_FIELDS = Object.values(CounterpartyDistinctField);
